import { withDependencies, named, type FactoryWithDependencies } from '@wix/thunderbolt-ioc'
import type { ServiceProvider } from '@wix/thunderbolt-symbols'
import { PageFeatureConfigSymbol } from '@wix/thunderbolt-symbols'
import type { ISdkStateDefinition } from '@wix/viewer-service-sdk-state/definition'
import { SdkStateDefinition as definition } from '@wix/viewer-service-sdk-state/definition'
import { SdkStateService as impl } from '@wix/viewer-service-sdk-state/implementations'
import type { SdkStateServicePageConfig } from './types'
import { name } from './symbols'

export const sdkStateService: FactoryWithDependencies<ServiceProvider<ISdkStateDefinition, typeof impl>> =
	withDependencies(
		[named(PageFeatureConfigSymbol, name)],
		(pageFeatureConfig: SdkStateServicePageConfig): ServiceProvider<ISdkStateDefinition, typeof impl> => {
			return {
				definition,
				impl,
				config: pageFeatureConfig,
				platformConfig: pageFeatureConfig,
			}
		}
	)
